import ResourceList from '../../resource/list';

const AssetsList = () => {

      return(
        <div>
          <ResourceList resource="cabins" name="Cabins"/>
        </div>
      )

}

export default AssetsList;